import { useAuth } from "@/contexts/AuthProvider";

export const useAuthorization = () => {
  const { permissions } = useAuth();
  const hasPermission = (permission: string): boolean => {
    return permissions.includes(permission);
  };

  const hasAnyPermission = (requiredPermissions: string[]): boolean => {
    return requiredPermissions.some((perm) => hasPermission(perm));
  };

  return {
    hasPermission,
    hasAnyPermission,
  };
};
